import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'immutable';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { getLanguageNameFromCode } from '../../../utils/langUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TranslateTemplateFieldGroupLabel = styled.span.withConfig({
  displayName: "TranslateTemplateSocialNetworksSection__TranslateTemplateFieldGroupLabel",
  componentId: "sc-1dexol3-0"
})(["font-size:16px;font-weight:600;text-transform:capitalize;"]);
export default function TranslateTemplateSocialNetworksSection(props) {
  const {
    languages,
    values
  } = props;
  const socialNetworkUrls = values.get(languages[0]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: socialNetworkUrls.map(link => {
      const {
        networkType,
        uuid
      } = link.toJS();
      return /*#__PURE__*/_jsx(UIAccordionItem, {
        className: "m-top-4",
        title: /*#__PURE__*/_jsx(TranslateTemplateFieldGroupLabel, {
          children: networkType.toLowerCase()
        }),
        children: languages.map((lang, langIdx) => {
          const isPrimary = langIdx === 0;
          const languageName = getLanguageNameFromCode(lang);
          const onChange = e => props.onChange(lang, networkType, uuid, e.target.value);
          const value = values.get(lang, List()).toJS();
          const currItem = value.find(translation => translation.uuid === uuid);
          return /*#__PURE__*/_jsx(UIFormControl, {
            verticalSeparation: "flush",
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.templateEditor.translateModal.sections.footer.footerLinksFieldLabels.url",
              options: {
                languageName
              }
            }),
            labelTooltip: isPrimary ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.templateEditor.translateModal.primaryLanguageFieldTooltip"
            }) : null,
            children: /*#__PURE__*/_jsx(UITextInput, {
              name: "url",
              onChange: onChange,
              readOnly: isPrimary,
              value: currItem ? currItem.url : ''
            })
          }, lang);
        })
      }, uuid);
    }).toArray()
  });
}